import React, { PureComponent } from 'react';
import classnames from 'classnames';
import truncate from 'util/misc/truncate';
import { isNil } from 'lodash';
import { formatPrice } from 'util/misc/format-price';
import { CURRENCY } from 'constants/cart';

import PropTypes from 'prop-types';
import t from 'translations';
import formatProductShortDescription from 'util/react/format-product-short-description';

const TRUNCATE_LIMIT = 32;

export default class ProductMetaGrid extends PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        original_price: PropTypes.string,
        short_description: PropTypes.array.isRequired,
        hasBadge: PropTypes.bool,
        price: PropTypes.any,
        teaser: PropTypes.any,
    };

    formatDiscount(original_price) {
        return (
            <span className="product-meta--price-discount">
                {t('products.instead_of')} {formatPrice(original_price)}
            </span>
        );
    }

    formatPrice(price) {
        return (
            <span className="product-meta--price-primary" itemProp="price">
                {formatPrice(typeof price === 'object' ? price.price : price)}
            </span>
        );
    }

    render() {
        const { title, price, teaser, short_description, original_price, hasBadge } = this.props;
        const hasTeaser = teaser !== null;
        const hasPrice = !isNil(price);
        const hasDiscount = !isNil(original_price);

        return (
            <div key="meta" className={classnames('product-meta', {
                'product-meta__is-ready': hasPrice,
            })}>
                {hasPrice && <div
                    className={classnames('product-meta--price', { 'product-meta--price__discounted': hasBadge })}
                    itemProp="priceSpecification"
                    itemScope
                    itemType="PriceSpecification"
                >
                    {hasPrice && this.formatPrice(price)}
                    {hasDiscount && this.formatDiscount(original_price)}
                </div>}
                {title && <h1 itemProp="name" className="u-reset product-meta--name" title={title}>
                    {truncate(title, TRUNCATE_LIMIT)}
                </h1>}

                {hasTeaser ? <meta itemProp="priceCurrency" content={CURRENCY}/> : null}
                <div
                    className="product-meta--short-description">{formatProductShortDescription(short_description)}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-meta/product-meta-grid.js